import {
  Flex,
  Table,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Thead,
  Box,
  Input,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  IChiTietDinhGia,
  IDropdownItem,
  IDinhGia,
  IChiTietThuaDat,
} from "../_types_";
import Dropdown from "./Dropdown";
import { numberFormat } from "../utils";

interface IProps {
  thuaDatChiTiet: IChiTietThuaDat;
}
export default function LichSuGiaDat({ thuaDatChiTiet }: IProps) {
  const [mdsd, setMdsd] = React.useState<IDropdownItem[]>([]);
  const [dsDinhGia, setDsDinhGia] = useState<IDropdownItem[]>([]);
  const [dinhGia, setDinhGia] = useState<IDinhGia>();
  const [chiTiet, setChiTiet] = React.useState<IChiTietDinhGia[]>([]);

  const [indexDinhGia, setIndexDinhGia] = useState<number>(1);

  useEffect(() => {
    initData();
  }, [thuaDatChiTiet]);

  const initData = () => {
    const mdResult = thuaDatChiTiet.thuaDat.mucDichSuDungs.map((p) => {
      const item: IDropdownItem = {
        value: p.kyHieu,
        lable: p.kyHieu,
      };
      return item;
    });
    setMdsd(mdResult);

    const rs = thuaDatChiTiet.dinhGias.map((p, index) => {
      const item: IDropdownItem = {
        lable: `${p.tenDuong} ${p.tenHem ?? ""}`,
        value: index,
      };
      return item;
    });
    setDsDinhGia(rs);
    const { dinhGias } = thuaDatChiTiet;
    setDinhGia(dinhGias[0]);
    setIndexDinhGia(0);
    setChiTiet(dinhGias[0].chiTiets);
  };

  return (
    <>
      <Box w="full" border="2px solid #fff" boxShadow="base">
        <TableContainer w="full">
          <Table size="sm">
            <Tbody>
              <Tr>
                <Th w="30%">Định giá:</Th>
                <Td>
                  <Dropdown data={dsDinhGia} selectedVal={indexDinhGia} />
                </Td>
              </Tr>
              <Tr>
                <Th>Thửa liền kề:</Th>
                <Td>{dinhGia?.thuaLienKe}</Td>
              </Tr>
              <Tr>
                <Th>Tên đường:</Th>
                <Td>{dinhGia?.tenDuong}</Td>
              </Tr>
              <Tr>
                <Th>Tên hẻm:</Th>
                <Td>{dinhGia?.tenHem}</Td>
              </Tr>
              <Tr>
                <Th>Tên đường giao:</Th>
                <Td>{dinhGia?.tenDuongGiao}</Td>
              </Tr>
              <Tr>
                <Th>Phương pháp định giá:</Th>
                <Td>{dinhGia?.phuongPhapDinhGia}</Td>
              </Tr>
              <Tr>
                <Th>Hệ số tiếp giáp:</Th>
                <Td>{dinhGia?.heSoTiepGiapDuong}</Td>
              </Tr>
              <Tr>
                <Th>Tổng giá:</Th>
                <Td>
                  {dinhGia?.tongGia ? numberFormat(dinhGia?.tongGia || 0) : ""}
                </Td>
              </Tr>
              <Tr>
                <Th>Giá thị trường:</Th>
                <Td>
                  {dinhGia?.giaThiTruong
                    ? numberFormat(dinhGia?.giaThiTruong || 0)
                    : ""}
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      <Flex
        w="full"
        flexDirection="column"
        mt="20px"
        border="1px solid #fff"
        padding="5px"
        borderRadius="5px"
        boxShadow="base"
      >
        <TableContainer w="full">
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Khu Vực</Th>
                <Th>DT Khu Vực</Th>
                <Th>MĐSD</Th>
                <Th>Diện tích</Th>
                <Th>Giá</Th>
              </Tr>
            </Thead>
            <Tbody>
              {chiTiet.map((p, index) => {
                return (
                  <Tr key={String(index)}>
                    <Td>{p.tenVung}</Td>
                    <Td>{p.dienTichVung}</Td>
                    <Td>
                      <Dropdown data={mdsd} selectedVal={p.mdsd} />
                    </Td>
                    <Td w="15%">{p.dienTich}</Td>
                    <Td w="25%">{p.gia}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Flex>
    </>
  );
}
